import { create } from 'zustand';

export interface ZorMeetingLinkState {
  meetingLink: string | null;
  setMeetingLink: (meetingLink: string) => void;
}

const useZorMeetingLinkStore = create<ZorMeetingLinkState>((set) => ({
  meetingLink: null,
  setMeetingLink: (meetingLink: string) => set(() => ({ meetingLink })),
}));

export default useZorMeetingLinkStore;
